module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"actions.choose.institutions":"Choisir des établissements","actions.start":"Commencer","audit.not.started":"Vous ne pouvez pas consulter les résultats des contrôles tant que l\u0027audit n\u0027a pas encore commencé.","audit.no.institutions":"Aucun établissement n\u0027est assigné à cet audit."}}')
  delete Component.options._Ctor
}
